// extracted by mini-css-extract-plugin
export default {"colorBlock":"LeftColor_colorBlock__0ifQd"};